import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { validateDateAfter, validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { VersionStore } from '@/modules/version/model/mixins';
import { ROUTE_NAME_VERSION } from '@/modules/version/router';
import versionService from '@/services/version';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useVersionAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        store: StringUtils.toNumber(route.query.store, VersionStore.Apple.value),
        version: '',
        assetLink: '',
        releasedDate: null
    });

    const validations = {
        assetLink: { required },
        releasedDate: { validateDate: validateDateAfter() },
        version: {
            required,
            format: validateFormat(/^\d+(.\d+){0,3}$/, 'Please enter in the correct format: Ex: 1.0.2')
        }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            versionService.create(model.store, model.version, model.assetLink, model.releasedDate?.getTime()),
        onSuccess: () => router.push({ name: ROUTE_NAME_VERSION.INDEX, query: { store: model.store } })
    });

    return { model, v$, create };
}
